import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
// import * as serviceWorker from './serviceWorker';
// import * as firebaseServiceWorker from './firebase-messaging-sw';



import Amplify, {Storage} from 'aws-amplify';
import awsmobile from './aws-exports';
import { initializeApp } from "firebase/app"
import { getMessaging } from "firebase/messaging";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCTCIWUg56x5q-OEKLbgGCeLA6Pa30RWwk",
  authDomain: "empushy-emulator.firebaseapp.com",
  databaseURL: "https://empushy-emulator.firebaseio.com",
  projectId: "empushy-emulator",
  storageBucket: "empushy-emulator.appspot.com",
  messagingSenderId: "637024112415",
  appId: "1:637024112415:web:15a7b2483220fc20bbaa2a",
  measurementId: "G-Q9VGDZ1NRK"
};

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const pushFirebaseConfig = {
  apiKey: "AIzaSyBMOG6hg0Kg1KHdxEsHA9FcFcHooCa7A2s",
  authDomain: "empushy-311ed.firebaseapp.com",
  databaseURL: "https://empushy-311ed.firebaseio.com",
  projectId: "empushy-311ed",
  storageBucket: "empushy-311ed.appspot.com",
  messagingSenderId: "441470046302",
  appId: "1:441470046302:web:89075ab819beee5f4f24cf"
};

const API_CONFIG = {
  // OPTIONAL - if your API requires authentication
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: 'eu-west-1:39c4dde5-31ca-4751-aa16-e0d511146a41',
    // REQUIRED - Amazon Cognito Region
    region: 'eu-west-1',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'eu-west-1_wWtInsFU8',
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: '2cur8lcv6l6f5iiqhs24idf789',
  },
  API: {
    endpoints: [
      {
        name: "DashboardAPI",
        endpoint: "https://5ekl4rlvd3.execute-api.eu-west-1.amazonaws.com/prod",
      },
      {
        name: "IntegrationAPI",
        endpoint: "https://ia4mus1iei.execute-api.eu-west-1.amazonaws.com/prod",
      }
    ]
  }
}

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const [
  productionRedirectSignIn,
  localRedirectSignIn,
] = awsmobile.oauth.redirectSignIn.split(',');

const [
  productionRedirectSignOut,
  localRedirectSignOut,
] = awsmobile.oauth.redirectSignOut.split(',');

const updatedAwsConfig = {
  ...awsmobile,
  oauth: {
    ...awsmobile.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
    redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
  }
}

Amplify.configure({ ...updatedAwsConfig, ...API_CONFIG });
const emulatorApp = initializeApp(firebaseConfig);
const pushApp = initializeApp(pushFirebaseConfig, "push");

/*if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js')
    .then(function(registration) {
      getMessaging(pushApp).useServiceWorker(registration);
    }).catch(function(err) {
    console.log('Service worker registration failed, error:', err);
  });
}*/

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
// firebaseServiceWorker.register()
